module.exports = __webpack_public_path__ + "img/RA-PLEX-Accenture.5dbee058.png";